/*
 * tetris_gui.js: GUI implementation for the Ham Tetris logic in tetris_logic.js
 *
 * LICENSE:
 * Copyright (c) 2013, Cyborg Evilham (http://cyborg.evilham.com)
 * BSD 2-Clause copyright and disclaimer apply.
 *
 */

const HT = require("./tetris_logic.js");

HT.size=10;
HT.square=function(){
  var sq=top.document.createElement("div");
  sq.className="square white";
  return sq;
}();
HT.addSquare=function(){
  var sq=HT.square.cloneNode(true);
  HT.target.appendChild(sq);
  var obj={
    domObject: sq,
    setPosition: function(x,y){HT.positionElement(this.domObject,x,y);},
    makeWhite:
      function() {
        var classes=this.domObject.className.split(' ');
        if (classes.indexOf("white")==-1)
          classes[classes.indexOf("black")]="white";
        this.domObject.className=classes.join(' ');
      },
    makeBlack:
      function() {
        var classes=this.domObject.className.split(' ');
        if (classes.indexOf("black")==-1)
          classes[classes.indexOf("white")]="black";
        this.domObject.className=classes.join(' ');
      },
    toggleColor:
      function(){
        var classes=this.domObject.className.split(' ');
        if (classes.indexOf("white")==-1)
          classes[classes.indexOf("black")]="white";
        else
          classes[classes.indexOf("white")]="black";
        this.domObject.className=classes.join(' ');
      },
  }
  return obj;
};
HT.positionElement=function(sq,x,y) {
  sq.style.left=x+"px";
  sq.style.top=y+"px";
}
/**
 * installer
 * @namespace HT
 * @method install
 * @param (string | div)
 */
HT.install = function (targetname) {
  if (typeof targetname == 'string' || targetname instanceof String)
    HT.target = top.document.getElementById(targetname);
  else
    HT.target = targetname;
  HT.startClassic();
};

HT.boardGUI=HT.boardGUI||{
  board: [],
  activate: function(i,j) {this.board[i][j].makeBlack();},
   deactivate: function(i,j) {this.board[i][j].makeWhite();},
  toggle: function(i,j) {this.board[i][j].toggleColor();},
  toggleMany:
    function(l) {
      for (var i=0; i<l.length; ++i)
        this.toggle(l[i][0],l[i][1]);
    },
};
HT.nextPieceGUI=HT.nextPieceGUI||{
  board: [],
  clear: function() {
    for (var i=0; i<this.board.length; ++i){
      for (var j=0; j<this.board[0].length; ++j){
        this.board[i][j].makeWhite();
      }
    }
  },
  toggle: function(i,j) {this.board[i][j].toggleColor();},
  toggleMany:
    function(l) {
      for (var i=0; i<l.length; ++i)
        this.toggle(l[i][0],l[i][1]);
    }
};
HT.scoreGUI=HT.scoreGUI||{
  update: function(lines,score,level) {
    this.score.innerHTML="<p>SCORE</p><p><b>"+score+"</b></p>";
    this.level.innerHTML="<p>LEVEL</p><p><b>"+level+"</b></p>";
    this.lines.innerHTML="<p>LINES</p><p><b>"+lines+"</b></p>";
  },
};
HT.height=HT.height||18;
HT.width=HT.width||10;
// Music source:
// http://www.laurasmidiheaven.com/0vg/Gameboy-Tetris.shtml
HT.music=HT.music||"/media/tetris_A.ogg";
HT.startClassic= function () {
  // Build GUI
  for (var i=0; i<HT.width; ++i) {
    HT.boardGUI.board[i]=[];
    for (var j=0; j<HT.height; ++j) {
      var sq=HT.addSquare();
      sq.setPosition(i*HT.size,(HT.height-(j+1))*HT.size);//invert y =D
      HT.boardGUI.board[i][j]=sq;
    }
  }
  for (var i=0; i<4; ++i) {
    HT.nextPieceGUI.board[i]=[];
    for (var j=0; j<4; ++j) {
      var sq=HT.addSquare();
      sq.setPosition((HT.width+2+i)*HT.size,(HT.height-(j+1))*HT.size);
      HT.nextPieceGUI.board[i][j]=sq;
    }
  }

  var d=top.document.createElement("div");
  d.className="score white";
  HT.scoreGUI.score=d.cloneNode(true);
  HT.scoreGUI.level=d.cloneNode(true);
  HT.scoreGUI.lines=d.cloneNode(true);
  HT.positionElement(HT.scoreGUI.score,(HT.width+1)*HT.size,HT.size);
  HT.positionElement(HT.scoreGUI.level,(HT.width+1)*HT.size,6*HT.size);
  HT.positionElement(HT.scoreGUI.lines,(HT.width+1)*HT.size,10*HT.size);
  HT.target.appendChild(HT.scoreGUI.score);
  HT.target.appendChild(HT.scoreGUI.level);
  HT.target.appendChild(HT.scoreGUI.lines);
  if (HT.music) {
    var music=top.document.createElement("audio");
    music.setAttribute("src", HT.music);
    //music.setAttribute("controls", "controls");
    music.setAttribute("autoplay", "autoplay");
    //music.setAttribute("loop", "loop");
    music.setAttribute("id", "tetris-music");
    /*
    music.style.position="absolute";
    music.style.width="150px";
    HT.positionElement(music, 3*HT.size, (HT.height+2)*HT.size);
    */
    HT.target.appendChild(music); // maybe just as a bonus?
  }

  //
  //setup
  //TODO: this is ugly >.<
  HT.gameplay.lostCallback=function(f){HT.intro=f;};
  HT.gameplay.boardCallback=function(l,newstate,source) {
    for (var k=0; k<l.length; ++k) {
      var i=l[k][0];
      var j=l[k][1];
    if (i>=0 && i< HT.width && j>=0 && j< HT.height) {
      if (newstate)
        HT.boardGUI.activate(i,j);
      else
        HT.boardGUI.deactivate(i,j);
      }
    }
  };
  HT.gameplay.lineCallback=function(lines,f) {
    if (lines.length>0) {
      var pieces=[];
      for (var l=0; l<lines.length; ++l) {
        var j=lines[l];
        for (var i=0; i<HT.boardGUI.board.length; ++i) {
          pieces[pieces.length]=[i,j];
        }
      }
      setTimeout(function(){HT.boardGUI.toggleMany(pieces);}, 100);
      setTimeout(function(){HT.boardGUI.toggleMany(pieces);}, 250);
      setTimeout(function(){f();},400);
    }
    else
      f();
  };
  HT.gameplay.nextPieceCallback=function(piece) {
    HT.nextPieceGUI.clear();
    var c=HT.gameplay.pieceCenter(piece);
    var goal=HT.gameplay.goalPiece(piece,[2-c[0],2-c[1]]);
    HT.nextPieceGUI.toggleMany(goal);
  };
  HT.gameplay.scoreCallback=function(lines,score,level){
    HT.scoreGUI.update(lines,score,level);
  }
  HT.gameplay.start(HT.height,HT.width);
};
HT.kdhandle=function(e) {
  if (!HT.target) return false;
  e=e||event;
  if (e.keyCode==37)
    HT.gameplay.moveLeft();
  if (e.keyCode==39)
    HT.gameplay.moveRight();
  if (e.keyCode==40) {
    if (!HT.gameplay.softDropTimer) {
      HT.gameplay.startSoftDropTimer();
    }
  }
  if (e.keyCode==66 || e.keyCode==88)
    HT.gameplay.rotateClockwise();
  if (e.keyCode==65 || e.keyCode==90 || e.keyCode==32)
    HT.gameplay.rotateCounterClockwise();
  if (e.keyCode==13)
    HT.intro();
};
HT.kuhandle=function(e) {
  if (!HT.target) return false;
  if (e.keyCode==40)
    HT.gameplay.stopSoftDropTimer();
};

// events
window.addEventListener("keydown", HT.kdhandle, false);
window.addEventListener("keyup", HT.kuhandle, false);

module.exports = HT;
